import { NextPage } from "next";
import { ReactNode } from "react";
import { useTheme } from "sparkl-ui";
import { Generator } from "../genie/generator";
import { GeneratorBar } from "../selectors/generator_bar";
import { GeneratorArea } from "./generator_area";
import { Navbar } from "./navbar/navbar";
import { RecentsGrid } from "./recents_grid/recents_grid";

export interface LandscapeGridProps {
  topNavHeight: string;
  children: ReactNode;
}

export const LandscapeGrid: NextPage<LandscapeGridProps> = ({
  topNavHeight,
  children,
}) => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0,1fr) minmax(0,1.618fr)",
        gridTemplateRows: `${topNavHeight} 1fr`,
        gridTemplateAreas: `"header header" "generator content"`,
        gridGap: `0 1rem`,
        width: "100vw",
        backgroundColor: theme.palette.accents_1,
        alignItems: "start",
      }}
    >
      <nav
        style={{
          gridArea: "header",
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: theme.palette.background,
          height: "100%",
        }}
      >
        <Navbar />
      </nav>
      <div
        style={{
          gridArea: "generator",
          height: "100%",
          display: "grid",
          alignContent: "start",
        }}
      >
        <GeneratorArea topNavHeight={topNavHeight} />
      </div>
      <div
        style={{
          gridArea: "content",
          paddingRight: "1rem",
        }}
      >
        {children}
      </div>
    </div>
  );
};
